module.exports = __webpack_public_path__ + "img/veci-white.ee91cf8a.png";